import type { PropsWithChildren } from '@shared/utils';
import { createContext, useMemo, useState } from 'react';

import {
  ChangeAssigneeModal,
  ChangeDueDateModal,
  FinishTaskConfirmationModal,
  IncompleteQuestionCreationTaskModal,
} from '../../containers';

export enum QuestionCreationTaskDetailsModalAction {
  QUESTION_COUNT_IS_NOT_COMPLETED = 'QUESTION_COUNT_IS_NOT_COMPLETED',
  FINISH_TASK = 'FINISH_TASK',
  CHANGE_ASSIGNEE = 'CHANGE_ASSIGNEE',
  CHANGE_DUE_DATE = 'CHANGE_DUE_DATE',
}

type ActionType = keyof typeof QuestionCreationTaskDetailsModalAction;

interface QuestionCreationTaskDetailsModalContext {
  openIncompleteQuestionCreationTaskModal: () => void;
  openFinishTaskModal: () => void;
  openChangeAssigneeModal: () => void;
  openChangeDueDateModal: () => void;
}

export const QuestionCreationTaskDetailsModalContext =
  createContext<QuestionCreationTaskDetailsModalContext | null>(null);

export default function QuestionCreationTaskDetailsModalProvider(
  props: Readonly<PropsWithChildren>,
) {
  const { children } = props;

  const [action, setAction] = useState<ActionType | null>(null);

  const handleCloseModal = () => {
    setAction(null);
  };

  const contextValue = useMemo(
    () => ({
      openIncompleteQuestionCreationTaskModal: () => setAction('QUESTION_COUNT_IS_NOT_COMPLETED'),
      openFinishTaskModal: () => setAction('FINISH_TASK'),
      openChangeAssigneeModal: () => setAction('CHANGE_ASSIGNEE'),
      openChangeDueDateModal: () => setAction('CHANGE_DUE_DATE'),
    }),
    [],
  );

  return (
    <QuestionCreationTaskDetailsModalContext.Provider value={contextValue}>
      {children}
      <IncompleteQuestionCreationTaskModal
        open={action === QuestionCreationTaskDetailsModalAction.QUESTION_COUNT_IS_NOT_COMPLETED}
        onClose={handleCloseModal}
      />
      <FinishTaskConfirmationModal
        open={action === QuestionCreationTaskDetailsModalAction.FINISH_TASK}
        onClose={handleCloseModal}
      />
      <ChangeAssigneeModal
        open={action === QuestionCreationTaskDetailsModalAction.CHANGE_ASSIGNEE}
        onClose={handleCloseModal}
      />
      <ChangeDueDateModal
        open={action === QuestionCreationTaskDetailsModalAction.CHANGE_DUE_DATE}
        onClose={handleCloseModal}
      />
    </QuestionCreationTaskDetailsModalContext.Provider>
  );
}
